import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiMapPin } from "react-icons/fi";
import { FaStar } from "react-icons/fa";
import "../styles/SavedJobs.css";



export default function SavedJobs() {
    const navigate=useNavigate()
  const [savedJobs, setSavedJobs] = useState([]);

  useEffect(() => {
    const jobs = JSON.parse(localStorage.getItem("savedJobs")) || [];
    setSavedJobs(jobs);
  }, []);

  const removeJob = (jobId) => {
    const updated = savedJobs.filter(job => job.id !== jobId);
    setSavedJobs(updated);
    localStorage.setItem("savedJobs", JSON.stringify(updated));
  };



  function timeAgo(dateStr) {
    const now = new Date();
    const d = new Date(dateStr);
    const seconds = Math.floor((now - d) / 1000);
    const units = [
      { name: "year", sec: 31536000 },
      { name: "month", sec: 2592000 },
      { name: "week", sec: 604800 },
      { name: "day", sec: 86400 },
      { name: "hour", sec: 3600 },
      { name: "minute", sec: 60 },
    ];
    for (let u of units) {
      const val = Math.floor(seconds / u.sec);
      if (val >= 1) return `${val} ${u.name}${val > 1 ? "s" : ""} ago`;
    }
    return "Just now";
  }



  return (
    <div className="saved-page-root">
      <button onClick={()=>navigate("/candidate-dashboard")}  className="saved-page-back" >←</button> 
      <h2 className="saved-page-title"> Saved Jobs</h2>
      

      {savedJobs.length === 0 ? (
        <p className="saved-empty-text">No saved jobs found</p>
      ) : (
        <div className="saved-job-grid">
          {savedJobs.map(job => (
            <div className="saved-job-card" key={job.id}>
              
              {/* Save / Remove icon */}
              <button
                className="saved-icon-btn save-icon"
                onClick={() => removeJob(job.id)}
                title="Remove from saved"
              >
                ✖
              </button>

              {/* Title + company */}
              <div className="saved-job-main">
                <div className="saved-title-row">
                {job.companyLogo ? (
            <img className="saved-logo" src={job.companyLogo} alt=""
            // alt={`${company} logo`} 
            />
          ) : null}
                  <div>
                    <h3 className="saved-job-title">{job.title}</h3>
                    <p className="saved-company">{job.company}</p>
                  </div>
                </div>

                {/* Meta */}
                <div className="saved-meta-row">
                  <div className="saved-meta-item"><FiMapPin className="saved-location-icon"/> {job.location}</div>
                  <div className="saved-meta-item"> {job.salary}</div>
                </div>
                

                {/* Description */}
                <p className="saved-short-desc">
                  {job.description || "We are looking for skilled candidates to join our team."}
                </p>

                {/* Skills */}
                {job.skills && (
                  <div className="saved-skills-row">
                    {job.skills.map((skill, i) => (
                      <span className="saved-skill" key={i}>
                        <FaStar className="saved-star" /> {skill}
                      </span>
                    ))}
                  </div>
                )}
              </div>

              {/* Footer */}
              <div className="saved-job-footer">
                <span className="saved-posted"> 
                <div className="pposted">
                     Posted {timeAgo(job.postedAt)} by {" "}
                     <span className="pposted-by">{job.postedBy}</span>
                </div>
                </span>

                <div className="saved-action-row">
                  <button className="saved-apply-btn" onClick={()=>navigate(`/job/${job.id}`)}>View</button>
                </div>
              </div>

            </div>
          ))}
        </div>
      )}
    </div>
  );
}
